<div class="cm-container" [style.width.px]="$width()" [style.height.px]="$height()">
    <div class="cm-background-container"><ng-content select="[cm-background]"></ng-content></div>
    <div class="cm-foreground-container">
        <svg
            [attr.viewBox]="'0 0 ' + $width() + ' ' + $height()"
            [attr.width]="$width()"
            [attr.height]="$height()"
            xmlns="http://www.w3.org/2000/svg"
            (mousedown)="onMouseDown($event, undefined); $event.stopPropagation()"
            (click)="onBackgroundClick($event)"
            (wheel)="onWheelEvent($event); $event.stopPropagation()"
            #curveContainer
        >
            <clipPath id="clipRgb">
                <rect width="100%" height="100%" />
            </clipPath>
            <g #curvePathsGroup class="cm-curve-paths-group"></g>
            <g #otherPathsGroup></g>
            @for (controlPoint of $controlPoints(); track $index) {
                <ng-container>
                    <circle
                        #circle
                        (mousedown)="onMouseDown($event, $index); $event.stopPropagation()"
                        (mouseenter)="onMouseEnterControlPoint($index)"
                        (mouseleave)="onMouseLeaveControlPoint()"
                        [attr.cx]="controlPoint.x * $width()"
                        [attr.cy]="(1 - controlPoint.y) * $height()"
                        [class.cm-active-circle]="$index === $selectedControlPoint() || $index === $hoveredControlPoint()"
                        class="cm-circle"
                        [attr.r]="$controlPointRadius()"
                        [attr.fill]="$controlPointColor()"
                    />
                </ng-container>
            }
        </svg>
    </div>
</div>
